import React from 'react';
import { FilterContainer, PageTitle } from 'resources/styles/TableStyle';
import { createGlobalStyle } from 'styled-components';
import SearchBox from 'components/input/SearchBox';
import { Row } from 'saladsoft-primitive';

const GlobalInputStyle = createGlobalStyle`
  .MuiOutlinedInput-input {
    padding: 10px !important;
  }
`;

const UserFilter = ({ onClickAdd }: { onClickAdd: () => void }) => {
  return (
    <div style={{ marginTop: 10 }}>
      <GlobalInputStyle />
      <Row justifyContent="space-between" width="100%">
        <FilterContainer>
          <PageTitle>회원 목록</PageTitle>
          <SearchBox paramKey="searchKeyword" placeholder="회원명 또는 이메일" />
        </FilterContainer>
      </Row>
    </div>
  );
};

export default UserFilter;
